import { links } from '@/services/dictionaries/links';
import { useSecurity } from '@/services/hooks/useSecurity';
import { Link } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const StaleContactLink = (): JSX.Element => {
    const { isReseller } = useSecurity();
    const { t } = useTranslation();
    const text = t('stalestatus');

    if (isReseller) {
        return <>{text}</>;
    }
    return (
        <Link rel="noreferrer" href={links.pruning} target="_blank">
            {t('stalestatus')}
        </Link>
    );
};
